import { AppBar, Box, Tab, Tabs } from '@mui/material'
import { NavLink, Outlet, useLocation } from 'react-router-dom'

const stripSlash = (s) => s.replace(/\/+$/, '')
export const FinancialReportIndex = () => {
    const location = useLocation()
    const allTabs = [
        {
            label: `Booking`,
            value: `/revenue-reports/financial-report/BOOKING`,
        },
        {
            label: `Payment Received`,
            value: `/revenue-reports/financial-report/PAYMENTRECEIVED`,
        },
        {
            label: `Refund`,
            value: `/revenue-reports/financial-report/REFUND`,
        },
        {
            label: `Commission`,
            value: `/revenue-reports/financial-report/COMMISSION`,
        },
        {
            label: `Revenue Breakdown`,
            value: `/revenue-reports/financial-report/REVENUEBREAKDOWN`,
        },
        {
            label: `Revenu Growth`,
            value: `/revenue-reports/financial-report/REVENUEGROWTH`,
        },
        {
            label: `Release Payment`,
            value: `/revenue-reports/financial-report/RELEASEPAYMENT`,
        },
    ]

    const pathname = stripSlash(location.pathname) || '/revenue-reports/financial-report/BOOKING'
    const subTabValue =
        allTabs.find((tab) => pathname === stripSlash(tab.value) || pathname.startsWith(stripSlash(tab.value) + '/'))?.value ?? '/revenue-reports/financial-report/BOOKING'
    return (
        <>
            <AppBar position="static" className="border-bottom" sx={{ boxShadow: 'none', background: 'transparent' }}>
                <Box>
                    <Tabs variant="scrollable" scrollButtons="auto" value={subTabValue}>
                        {allTabs.map((item, i) => (
                            <Tab key={i} style={{ textTransform: 'capitalize' }} label={item.label} value={item.value} component={NavLink} to={item.value} />
                        ))}
                    </Tabs>
                </Box>
            </AppBar>
            <div className="p-0 flex-fill mt-3 custom_scroll">
                <Outlet />
            </div>
        </>
    )
}
